import TrendingDownIcon from "@mui/icons-material/TrendingDown";
import TrendingUpIcon from "@mui/icons-material/TrendingUp";
import { Card, CardContent, Box, Typography, Skeleton } from "@mui/material";

interface MetricCardProps {
    icon: React.ReactNode;
    title: string;
    value: string;
    percentage?: number;
    loading?: boolean;
}

export function MetricCard({
    icon,
    title,
    value,
    percentage,
    loading,
}: MetricCardProps) {
    const isPositive = (percentage ?? 0) >= 0;

    return (
        <Card
            sx={{
                borderRadius: 2,
                height: "100%",
            }}
            variant="outlined"
        >
            <CardContent>
                <Box display="flex" justifyContent="space-between">
                    {loading ? (
                        <Skeleton
                            animation="wave"
                            variant="rectangular"
                            width={40}
                            height={40}
                            sx={{ borderRadius: 2 }}
                        />
                    ) : (
                        <Box
                            sx={{
                                width: 40,
                                height: 40,
                                borderRadius: 2,
                                bgcolor: "grey.100",
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                            }}
                        >
                            {icon}
                        </Box>
                    )}

                    {percentage !== undefined && !loading && (
                        <Box display="flex" alignItems="center" gap={0.5}>
                            {isPositive ? (
                                <TrendingUpIcon
                                    fontSize="small"
                                    color="success"
                                />
                            ) : (
                                <TrendingDownIcon
                                    fontSize="small"
                                    color="error"
                                />
                            )}
                            <Typography
                                variant="caption"
                                color={
                                    isPositive ? "success.main" : "error.main"
                                }
                            >
                                {percentage > 0 ? "+" : ""}
                                {percentage}%
                            </Typography>
                        </Box>
                    )}
                </Box>

                {loading ? (
                    <Skeleton animation="wave" variant="text" sx={{ mt: 2 }} />
                ) : (
                    <Typography variant="h6" mt={2}>
                        {value}
                    </Typography>
                )}

                {loading ? (
                    <Skeleton animation="wave" variant="text" width="20%" />
                ) : (
                    <Typography variant="body2" color="text.secondary">
                        {title}
                    </Typography>
                )}
            </CardContent>
        </Card>
    );
}
